module.exports = __webpack_public_path__ + "static/img/23.2cdb0550.png";